import styled from 'styled-components';
import theme from '|/components/base/theme';
import {
  Button as BaseButton
} from '|/helpers/app-framework';
import AlertTriangle from '|/icons/alert-triangle.svg';

export const AlertIcon = styled(AlertTriangle)`
  transform: scale(2.2);
  width: 25px;
  height: 25px;
  color: var(--colors-primary-yellow-2);
`;

export const BodyText = styled.p`
  color: var(--colors-neutral-gray-5);
  max-width: 375px;
  text-align: center;
`;

export const BoldText = styled.p`
  color: var(--colors-primary-blue-6);
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 8px;
  margin-top: 24px;
  text-align: center;
`;

export const Button = styled(BaseButton)`
  width: 251px;
`;

export const ButtonWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-top: 40px;
  gap: 14px;

  @media (min-width: ${theme.breakpoints.sm}) {
    flex-direction: row;
    justify-content: center;
  }
`;

export const ContentWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 100px 30px 50px;
  position: relative;

  @media (min-width: ${theme.breakpoints.sm}) {
    padding-top: 50px;
  }
`;
